import React from 'react';
import { titleize } from 'underscore.string';
import { sluggify } from '../../../utils/localization/utils';
import PropTypes from 'prop-types';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import { useTranslation } from 'react-i18next';

/*
 * The component is for rendering reference numbers of the following schema:
 *
 * [{
 *   name: "Mike"
 *   value: "Seay"
 * }]
 *
 * The intention is to wrap this in a container div to control the width.
 */

const ReferenceNumbersList = (props) => {
  const reference_numbers = props.reference_numbers;

  return (
    <div className="grid grid-cols-2 grid-gap-4">
      {reference_numbers.map((reference, idx) => (
        <ReferenceNumber
          className="mb-3"
          key={reference.value + idx}
          reference={reference}
        />
      ))}
    </div>
  );
};

ReferenceNumbersList.propTypes = {
  reference_numbers: PropTypes.array,
};

ReferenceNumbersList.defaultProps = {
  reference_numbers: [],
};

const ReferenceNumber = ({ reference, className }) => {
  const { t } = useTranslation();
  return (
    <DescriptionListItem
      label={titleize(t(sluggify(reference.name)))}
      className={className}
      dataTestId={reference.name}
    >
      {reference.value}
    </DescriptionListItem>
  );
};

ReferenceNumber.propTypes = {
  reference: PropTypes.object,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ReferenceNumbersList;
